module.exports = __webpack_public_path__ + "static/media/ndrill.1c1136f7.jpeg";